"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ReactLink = _interopRequireDefault(require("@micado-digital/react-link/ReactLink"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _UserIcon = _interopRequireDefault(require("./UserIcon.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UserIcon = function UserIcon() {
  var _systemLink;
  var systemLink = (0, _useSystemLinks.default)();
  var css = (0, _UserIcon.default)();
  var myAccountUrl = (_systemLink = systemLink("shop-myaccount")) !== null && _systemLink !== void 0 ? _systemLink : "/";
  return /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
    "aria-label": "user",
    className: (0, _clsx.default)(css.userIcon, "mco-shop-user-icon"),
    to: myAccountUrl
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: "/img/icons/shop/user.svg",
    size: 24
  }));
};
var _default = UserIcon;
exports.default = _default;